/**
 * DIV-038 (#116 item 40): is this shopper on a connection where every request
 * we can avoid is worth avoiding? True on 2g/3g effective types and when the
 * shopper asked for reduced data (Save-Data). `navigator.connection` exists on
 * Chromium and most Android browsers; where it is absent the answer is false
 * and nothing changes. Read at call time — the connection can change mid-page.
 */
export function isConstrainedNetwork(): boolean {
  const connection = (navigator as Navigator & { connection?: { effectiveType?: string; saveData?: boolean } }).connection;
  if (!connection) return false;
  if (connection.saveData === true) return true;
  const type = connection.effectiveType;
  return type === "slow-2g" || type === "2g" || type === "3g";
}
